var log = function (identifier, values, force) {
    if (env == 'dev' || force) {
        console.log(identifier, values);
    }
};